export default __webpack_public_path__ + "static/media/successIcon.c65a986f.svg";